import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { hrReportSearchFrom } from '@/features/hr-reports/api'
import { HrReportScreen } from '@/features/hr-reports/report-screen'
import { hasGrant } from '@/lib/me'
export const Route = createFileRoute('/_authenticated/hr/reports/permission-requests')({
  validateSearch: (s) => hrReportSearchFrom(s),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'hr_report.view')) throw redirect({ to: '/hr' })
  },
  component: () => {
    const s = Route.useSearch()
    const n = useNavigate()
    return (
      <HrReportScreen
        report="permission-requests"
        search={s}
        onSearchChange={(next) => void n({ search: next as never })}
      />
    )
  },
})
